import {ROOT_PATH} from '@/paths';
import compilePath from './compilePath';

/**
 * Query params that make an ez-rails auth page (`/sign_in`, `/create_account`) send the user back to
 * `currentUrl` once they finish authenticating. See docs/modules/authentication.md §9.
 *
 * Returns `{}` — i.e. no param — when there is nothing useful to return to. `compilePath` omits the
 * `?` entirely for an empty object, so the resulting URL is byte-identical to one built without it.
 *
 * `ROOT_PATH` is skipped deliberately: ez-rails' `sanitize_redirect` discards `"/"`, so sending it
 * would be a no-op, and leaving it off keeps the homepage's auth links unchanged. Callers pass
 * `router.asPath`, which carries the query string and hash, so only the pathname is compared —
 * `/?utm_source=email` is still the homepage.
 */
export const authReturnParams = (currentUrl?: string): {redirect_url?: string} =>
  !currentUrl || currentUrl.split(/[?#]/, 1)[0] === ROOT_PATH ? {} : {redirect_url: currentUrl};

/** An ez-rails auth URL carrying the return destination. */
export const buildAuthPath = (authPath: string, currentUrl?: string): string =>
  compilePath(authPath, {}, authReturnParams(currentUrl));
